import { render, staticRenderFns } from "./ContractEditorCore.vue?vue&type=template&id=4b6eb588&scoped=true&"
import script from "./ContractEditorCore.vue?vue&type=script&lang=js&"
export * from "./ContractEditorCore.vue?vue&type=script&lang=js&"
import style0 from "./ContractEditorCore.vue?vue&type=style&index=0&id=4b6eb588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6eb588",
  null
  
)

export default component.exports